<script setup lang="ts">

const authStore = useAuthStore();
const accountAddress = computed(() => authStore.user?.accountAddress ?? "");
const activeBrowserAddress = computed(() => authStore.activeBrowserAddress ?? "");
</script>

<template>

  <UModal
    v-model="authStore.mismatchedWalletModal"
    :ui="{
      shadow: 'shadow-none',
      background: '!bg-transparent',
    }">
    <GenericPanel class="flex flex-col max-w-[300px] mx-auto p-6 flex-centered">

      <UButton
        icon="i-tabler-x"
        class="absolute top-1 right-1"
        size="sm"
        variant="ghost"
        color="gray"
        @click="authStore.toggleMismatchedWalletModal(false)" />

      <h1 class="font-medium text-gray-700 dark:text-gray-200 mb-4 mt-4">
        Your wallets are mismatched
      </h1>

      <div class="flex flex-col items-center space-y-3 text-center">

        <div class="">
          <p class="text-2xs text-gray-500 dark:text-gray-400 font-medium">
            Currently active wallet
          </p>
          <p class="mt-0.5 font-medium font-mono text-sm">
            {{ ellipsis(activeBrowserAddress, 6) }}
          </p>
        </div>

        <UIcon name="i-tabler-square-arrow-down" class="text-lg text-gray-500" />

        <div class="">
          <p class="text-2xs text-gray-500 dark:text-gray-400 font-medium">
            Manually switch to this wallet
          </p>
          <p class="mt-0.5 font-medium font-mono text-sm">
            {{ ellipsis(accountAddress, 6) }}
          </p>
        </div>

      </div>

    </GenericPanel>
  </UModal>

</template>
